import { DialogType } from '@tableau/widgets';
import * as React from 'react';
import { ModalInstance, ReactModalService } from '../../ts/services/ReactModalService';
import { AddActiveDirectoryServerUsersDialog } from '../components/AddActiveDirectoryServerUsersDialog';
import { AddActiveDirectorySiteUsersDialog } from '../components/AddActiveDirectorySiteUsersDialog';

const serverAndSiteUsersDialogStyle: React.CSSProperties = {
  width: 'auto',
  height: 'auto',
  paddingTop: '18px',
  paddingBottom: '12px',
  paddingLeft: '12px',
  paddingRight: '12px'
};

function showAddActiveDirectoryUsersToSiteDialog(availableQuota: number): ng.IPromise<any> {
  let modalInstance: ModalInstance;
  const dialogProps = {
    dismiss: () => modalInstance && modalInstance.dismiss(),
    close: (result: any) => modalInstance && modalInstance.close(result),
    availableQuota: availableQuota
  };

  modalInstance = ReactModalService.open({
    type: DialogType.Uber,
    dialogContent: React.createElement(AddActiveDirectorySiteUsersDialog, dialogProps),
    testId: 'addActiveDirectorySiteUsersDialog',
    showCloseButton: true,
    dialogStyle: serverAndSiteUsersDialogStyle,
    shouldNotSetDefaultWidth: true
  });

  return modalInstance.result;
}

function showAddActiveDirectoryUsersToServerDialog(): ng.IPromise<any> {
  let modalInstance: ModalInstance;
  const dialogProps = {
    dismiss: () => modalInstance && modalInstance.dismiss(),
    close: (result: any) => modalInstance && modalInstance.close(result),
  };

  modalInstance = ReactModalService.open({
    type: DialogType.Uber,
    dialogContent: React.createElement(AddActiveDirectoryServerUsersDialog, dialogProps),
    testId: 'addActiveDirectoryServerUsersDialog',
    showCloseButton: true,
    dialogStyle: serverAndSiteUsersDialogStyle,
    shouldNotSetDefaultWidth: true
  });

  return modalInstance.result;
}

export const AddActiveDirectoryUsersAction = {
  showAddActiveDirectoryUsersToSiteDialog, showAddActiveDirectoryUsersToServerDialog
};
